import { render, staticRenderFns } from "./CareerAiInputArea.vue?vue&type=template&id=34e33b5c&scoped=true"
import script from "./CareerAiInputArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerAiInputArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/career-ai/career-ai-input.scss?vue&type=style&index=0&id=34e33b5c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e33b5c",
  null
  
)

export default component.exports